import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from '@jupiter/plugin-runtime/router';
import ConnectionRelativePaths from '@/router-config/paths';
import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
export default (function (props) {
  var children = props.children;
  var history = useHistory();
  var dispatch = useDispatch();
  var resetCreatorMarketplaceState = dispatch.findCreatorsModel.resetState;
  useEffect(function () {
    // need save creatorMarketplace state, others paths will reset state
    var saveCreatorMarketplaceStatePaths = [ConnectionRelativePaths.CREATOR_MARKETPLACE, ConnectionRelativePaths.CREATOR_DETAIL];
    if (!saveCreatorMarketplaceStatePaths.includes(history.location.pathname)) {
      resetCreatorMarketplaceState();
    }
  }, [history.location.pathname]);
  return /*#__PURE__*/_jsx(_Fragment, {
    children: children
  });
});